import { z } from 'zod'

import DEFAULT_PAGE_SIZE from '@/constants/default-page-size'
import { columnsSchema, labelAndValue } from '@/utils/zod'

export const classesFiltersSchema = z.object({
  id: z.array(labelAndValue()).optional(),
  academicLevelId: z.array(z.string()).optional(),
  tutorId: z.array(labelAndValue()).optional(),
  studentId: z.array(labelAndValue()).optional(),
  page: z.number().catch(1),
  pageSize: z.number().catch(DEFAULT_PAGE_SIZE),
  ...columnsSchema.shape
})

export type ClassesFiltersKey = keyof z.infer<typeof classesFiltersSchema>
